<template>
  <button 
    :type="type" 
    class="btn d-inline-flex align-items-center justify-content-center"
    :class="[colorClass, sizeClass, buttonClass]"
    :disabled="disabled || loading"
    @click="$emit('click')"
  >
    <div
      v-show="loading" 
      role="status"
      class="loading-button-spinner mr-1" 
      :class="spinnerClass"
    >
      <span class="sr-only">Loading...</span>
    </div>

    <slot name="icon-before"></slot>
    <slot>{{ loading && loadingLabel ? loadingLabel : label }}</slot>
  </button>
</template>

<script>
export default {
  name: "LoadingButton",

  props: {
    type: {
      type: String,
      default: "button",
      validator: (value) => ["button", "submit", "reset"].includes(value)
    },

    size: {
      type: String,
      validator: (value) => ["sm", "lg"].includes(value)
    },

    color: {
      type: String,
      default: "primary",
      validator: (value) => ["primary", "secondary", "success", "danger", "warning", "info", "light", "dark"].includes(value)
    },

    outline: {
      type: Boolean, 
      default: false
    },
    
    buttonClass: {
      type: String
    },

    label: {
      type: String 
    },

    loadingLabel: {
      type: String, 
    },

    spinnerType: {
      type: String, 
      default: "border",
      validator: (value) => ["border", "grow"].includes(value)
    },

    loading: {
      type: Boolean, 
      default: false
    },

    disabled: {
      type: Boolean, 
      default: false
    }
  },

  computed: {
    colorClass() {
      return `btn-${this.outline ? "outline-" : ""}${this.color}`;
    },

    sizeClass() {
      return this.size ? `btn-${this.size}` : "";
    },

    spinnerClass() {
      return `spinner-${this.spinnerType}`;
    }
  }
}
</script>

<style scoped>
.loading-button-spinner {
  width: 1em;
  height: 1em;
  vertical-align: middle;
}
</style>  